import React from 'react'
import styles from '../styles/aboutcomponent.module.css';
import vanchitgram from '../../../assets/about/projects/Vanchit-Gram-1.jpg';
import swamivivikanand from '../../../assets/about/projects/image_008.jpeg';
import early_life from '../../../assets/about/20190407_090900-1.jpg';
import ignited_mind from '../../../assets/about/20190111_185822-1.jpg';
import sir_teaching from '../../../assets/about/DSC00158-min-480x320.jpg';
import thebeginning from '../../../assets/about/the-beginning.jpg';
import thejourney from '../../../assets/about/20190408_154920-1.jpg';
import pillar from '../../../assets/about/pillar-4.jpg';
import Dnyanchatra from '../../../assets/about/projects/Dnyanchatra-3-1280x868.jpg';
import Sugar_School from '../../../assets/about/projects/Screenshot-2024-01-07-at-15.51.45-480x340.png';
import family6 from '../../../assets/about/projects/family6-300x200.jpg';
import computer_lab from '../../../assets/about/projects/Computer-Lab-1-300x200.jpg';
import Sewing_machine from '../../../assets/about/projects/training-centre-480x361.jpeg';
import Savitri_Woomen_Power from '../../../assets/about/projects/Women-Empowerment-480x361.jpeg';
import Education_For_Elders from '../../../assets/about/projects/Screenshot-2023-12-17-at-11.46.37-e1702794362811.png';
import Global_Classroom from '../../../assets/about/projects/Teresa-480x412.jpg';
import Open_Library from '../../../assets/about/projects/Done-480x360.jpg';
import gaushala from '../../../assets/about/projects/Gaushala-5-300x204.jpg';
import Mobile_hospital from '../../../assets/about/projects/Mobile-Hospital-768x522.jpg';
import InnovationLab from '../../../assets/about/projects/image_016.jpeg';
import EntrepreneurSkillProgram from '../../../assets/about/projects/image_018.jpeg';
import AgriculturalTrainingCente from '../../../assets/about/projects/image_019.jpeg';
import Automotive  from '../../../assets/about/projects/image_021.jpeg';
import Bakery   from '../../../assets/about/projects/image_025.jpeg';
import Laundry1   from '../../../assets/about/projects/image_027.jpeg';
import Laundry2   from '../../../assets/about/projects/image_028.jpeg';
import globalEducation1   from '../../../assets/about/projects/IMG20250818071009.jpg';
import globalEducation2   from '../../../assets/about/projects/IMG20260320080709.jpg';
const Projects = () => {
  return (
       <div className={styles.about_component}>
       {/* ================= PROJECTS ================= */}
            <div id="projects" className={styles.sectionAnchor}>
              <h2>PROJECTS IN SNEHWAN</h2>
    
              <h3>Pillar 1 — Education &amp; Shelter</h3>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Swami Vivekanand Dnyanalay (Residential Care)</h4>
                  <p>
                    For children left vulnerable by the devastating agrarian
                    crisis—many of whom have lost parents to farm-related debt and
                    suicides—Snehwan is more than a shelter; it is a home where
                    childhood is restored. We provide a safe haven, comprehensive
                    education, and daily nutrition, helping these resilient young
                    souls transform tragedy into a foundation for a
                    purpose-driven life.
                  </p>
                </div>
                <div>
                  <img src={swamivivikanand} alt="Swami Vivekanand Dnyanalay" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Vanchitgram (Uplifting the Nandi Samaj)</h4>
                  <p>
                    Vanchitgram is rewriting the destinies of 30 young girls from
                    the Nandi Samaj in Bhosari who once survived by collecting
                    trash and begging on the streets. Today, they receive
                    full-time education and proper nourishment, and reclaim their
                    dignity through the grace and discipline of classical Bharat
                    Natyam dance.
                  </p>
                </div>
                <div>
                  <img src={vanchitgram} alt="Vanchitgram" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Dnyanchatra (Preventing Dropouts &amp; Tribal Empowerment)</h4>
                  <p>
                    Poverty should never be the period at the end of a child's
                    educational journey. Dnyanchatra rehabilitates dropouts from
                    slums and rural areas, with a cornerstone commitment to
                    Adivasi (tribal) girls from Thakarwadi, providing full
                    education and family rations.
                  </p>
                </div>
                <div>
                  <img src={Dnyanchatra} alt="Dnyanchatra" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Sugar School (On-Site Mobile Education)</h4>
                  <p>
                    During the sugarcane cutting season, children of migrant
                    workers are uprooted from home. Right amidst the cane fields,
                    our Sugar School provides uninterrupted education, warm
                    blankets, and nutritious food — with older Snehwan students
                    stepping up to teach and mentor the visiting children.
                  </p>
                </div>
                <div>
                  <img src={Sugar_School} alt="Sugar School" loading="lazy" />
                </div>
              </div>
    
              <h3>Pillar 2 — Skill Development &amp; Empowerment</h3>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Bharatratna Nanaji Deshmukh Skill Development Center</h4>
                  <p>
                    Inspired by Nanaji Deshmukh's Gramodaya (village upliftment)
                    vision, this center provides comprehensive, multi-disciplinary
                    vocational training that transforms raw potential into
                    masterful craftsmanship and practical trades, fulfilling his
                    dream of self-sustaining, economically independent villages.
                  </p>
                </div>
                <div>
                  <img src={family6} alt="Skill development center" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Industry 4.0 Innovation Lab</h4>
                  <p>
                    This cutting-edge lab plunges students into modern
                    manufacturing — mastering Robotics, the Internet of Things
                    (IoT), and smart automation, dismantling the rural-urban tech
                    divide.
                  </p>
                </div>
                <div>
                  <img src={InnovationLab} alt="InnovationLab" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Computer Training Center: Bridging the Digital Divide</h4>
                  <p>
                    Our Computer Training Center empowers over 150 children from
                    Snehwan and surrounding villages with practical foundation
                    skills — PowerPoint, Excel, email, safe browsing, and typing
                    in Marathi — alongside computer hardware, Python programming,
                    and hands-on AI tools like ChatGPT.
                  </p>
                </div>
                <div>
                  <img src={computer_lab} alt="Computer training center" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Dr. Kalam Agri-Entrepreneur Skill Program</h4>
                  <p>
                    Inspired by Dr. A.P.J. Abdul Kalam, this program transforms
                    rural youth into socially responsible innovators — mastering
                    the production and business of agricultural goods, from pure
                    oils to traditional spices.
                  </p>
                </div>
                <div>
                  <img src={EntrepreneurSkillProgram} alt="EntrepreneurSkillProgram" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Agricultural Training Center</h4>
                  <p>
                    By blending ancestral agrarian wisdom with climate-smart
                    technologies — mushroom cultivation, hydroponics, and vertical
                    farming — we empower students to achieve high-yield, profitable
                    harvests regardless of land or water scarcity.
                  </p>
                </div>
                  <div>
                  <img src={AgriculturalTrainingCente} alt="AgriculturalTrainingCente" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Automotive &amp; Mechanical Skill Center (Garage)</h4>
                  <p>
                    Rigorous, professional-grade training in automotive
                    mechanics — repair, maintenance, and diagnostics of modern
                    two-wheelers and four-wheelers.
                  </p>
                </div>
                  <div>
                  <img src={Automotive} alt="Automotive" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Bakery &amp; Culinary Arts Training Center</h4>
                  <p>
                    Training youth and local women in baking and commercial
                    confectionery — from daily bread to artisan pastries — so
                    students can launch their own bakery enterprises.
                  </p>
                </div>
                <div>
                  <img src={Bakery} alt="Bakery " loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Savitri Women Empowerment Center</h4>
                  <p>
                    Drawing inspiration from Savitribai Phule, this center trains
                    local women in sewing and tailoring, stitching together
                    financial freedom, entrepreneurial confidence, and resilience.
                  </p>
                </div>
                <div>
                  <img src={Savitri_Woomen_Power} alt="Savitri Women Empowerment Center" loading="lazy" />
                  <img src={Sewing_machine} alt="Sewing machine training" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Laundry Skill Development Center</h4>
                  <p>
                    A professional training ground for hygiene management, fabric
                    care, and service entrepreneurship — instilling discipline and
                    work ethic in our youth.
                  </p>
                </div>
                 <div>
                  <img src={Laundry1} alt="Laundry1" loading="lazy" />
                  <img src={Laundry2} alt="Laundry2" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Education for Elders</h4>
                  <p>
                    By offering foundational education and basic English to our
                    elders and staff members, we erase the silent burdens of
                    illiteracy carried for decades, fostering a community-wide
                    culture of growth.
                  </p>
                </div>
                <div>
                  <img src={Education_For_Elders} alt="Education for elders" loading="lazy" />
                </div>
              </div>
    
              <h3>Pillar 3 — Holistic Community &amp; Wellbeing</h3>
    
              <div className={styles.about_container}>
                <div>
                  <h4>The Open Library (India's First Container Library)</h4>
                  <p>
                    With 15,000 books freely accessible to everyone, this space is
                    a vessel of dreams. Our "One Book, One Movie" initiative
                    rewards children's reading with weekend educational films.
                  </p>
                </div>
                <div>
                  <img src={Open_Library} alt="Open Library" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Kamdhenu Goushala</h4>
                  <p>
                    By fostering and protecting native Desi Gir cows and their
                    calves, the Kamdhenu Goushala instills empathy, gentleness, and
                    a sense of sacred responsibility, connecting children to the
                    traditional agrarian soul of India.
                  </p>
                </div>
                <div>
                  <img src={gaushala} alt="Kamdhenu Goushala" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Mobile Hospital &amp; Health Camps</h4>
                  <p>
                    Our mobile health camps close the healthcare gap for our most
                    forgotten neighbors, serving street-dwelling populations with
                    immediate medical care and vital hygiene education.
                  </p>
                </div>
                <div>
                  <img src={Mobile_hospital} alt="Mobile Hospital" loading="lazy" />
                </div>
              </div>
    
              <div className={styles.about_container}>
                <div>
                  <h4>Global Classroom</h4>
                  <p>
                    Global volunteers from countries like Japan, Kenya, Sri Lanka,
                    the Czech Republic and beyond dedicate their time to the
                    children at Snehwan, enhancing cultural exchange and offering
                    a truly global classroom experience.
                  </p>
                </div>
                <div>
                  <img src={globalEducation2} alt="Global Classroom" loading="lazy" />
                  <img src={globalEducation1} alt="Global Classroom" loading="lazy" />
                  <img src={Global_Classroom} alt="Global Classroom" loading="lazy" />
                </div>
              </div>
            </div>
   </div>
  )
}

export default Projects